<div class="mdi-container" id="tdo-mdi-manager" data-cy="mdi-manager-container">
  <ng-content></ng-content>
</div>
